<div class="dialog-container">
  <arsultima-dialog-header [title]="title" (closeClicked)="close()"></arsultima-dialog-header>
  <section class="m-t-xs small">
    <ng-content></ng-content>
  </section>
</div>
